import httpInstance from "../httpInstance";

export const postProfilePicture = async (jwtToken: string, image: File) => {
  const endpoint = `userImage/`;
  const boundary = '--------------------------' + Date.now().toString(16);

  // Crear el objeto FormData para enviar la imagen
  const formData = new FormData();
  formData.append('image', image, 'image.jpg');

  // Configurar el encabezado de autorización con el token JWT
  const headers = {
    Authorization: jwtToken,
    'Content-Type': `multipart/form-data; boundary=${boundary}`,
  };

  try {
    const response = await httpInstance.post(endpoint, formData, { headers });

    // Procesar la respuesta del servidor
    if (response.data) {
      // Realiza las acciones necesarias con la respuesta del servidor aquí
    }
  } catch (error) {
    console.error('Error en la solicitud:', error);
  }
};